import { setCollectionModal, showBankingCommentsModal } from "@actions/modals";
import collections from "@api/collections";
import { connect } from "react-redux";
import BaseCollection from "./BaseCollection";

class CollectionPerformance extends BaseCollection {
  fnRowClick = collections.getBankingPerformanceDetail;
  fnRefresh = collections.getBankingPerformance;
  fnGetSummaryPdf = collections.getPerformanceSummaryPdf;
  fnGetSummaryCsv = collections.getPerformanceSummaryCsv;
  fnGetVariancePdf = collections.getPerformanceVariancePdf;
  fnGetExport = collections.getBankingPerformanceExport;
  fnGetSummaryReportPdf = collections.getSummaryReportPdf;
  isPerformance = true;

  reportName = "Machine Net Income PDF";
  reportNameCsv = "Machine Net Income CSV";
  reportFileName = "Collection Net Income";
  summaryReportFileName = "Summary Report";
  exportFileName = "Collection Net Income Export CSV";
  modalTitle = "Collection Week Net Income";
}

const mapStateToProps = (state) => {
  return {
    installationsFilters: state.installationsFilters,
    collectionsFilters: state.collectionsFilters,
    collectionModal: state.collectionModal,
  };
};

export default connect(mapStateToProps, {
  setCollectionModal,
  showBankingCommentsModal,
})(CollectionPerformance);
